import * as React from 'react';

import Icon from '../../components/Icon/Icon';

const SvgMinusComponent = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
    >
        <line x1='5' y1='12' x2='19' y2='12'></line>
    </svg>
);

const SvgMinus = (props: any) => (
    <Icon {...props}>
        <SvgMinusComponent />
    </Icon>
);

export default SvgMinus;
